const { $ } = window;

// todo 移動至共用元件
// eslint-disable-next-line no-extend-native
String.prototype.format = function format(args) {
  let result = this;
  if (arguments.length > 0) {
    if (arguments.length === 1 && typeof args === 'object') {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in args) {
        if (args[key] !== undefined) {
          const reg = new RegExp(`({${key}})`, 'g');
          result = result.replace(reg, args[key]);
        }
      }
    } else {
      for (let i = 0; i < arguments.length; i += 1) {
        // eslint-disable-next-line prefer-rest-params
        if (arguments[i] !== undefined) {
          const reg = new RegExp(`({[${i}]})`, 'g');
          // eslint-disable-next-line prefer-rest-params
          result = result.replace(reg, arguments[i]);
        }
      }
    }
  }
  return result;
};

const carHtmlFormat = '<a href="#" class="dropdown-item carClass">{val}</a>';
const typesHtmlFormat = '<a href="#" class="dropdown-item typeClass">{val}</a>';
const youtubeHtmlFormat = `<div class="video-item col-12 col-md-6">
                            <div class="video-tag">{tag}</div>
                            <article class="video-subtext-swiper">
                                <div class="video">
                                    <lite-youtube src="{yt}" params="playsinline=0&autohide=0&modestbranding=1&fs=0&enablejsapi=1&controls=1&rel=0">
                                    </lite-youtube>
                               </div>
                            <h4>{title}</h4>
                             </article>
                             </div>`;
let currentDatas = [];
let typesData = [];
let currentType = '-1';

function setYoutubeHtml(datas) {
  let htmlYoutube = '';
  datas.forEach((item) => {
    htmlYoutube += youtubeHtmlFormat.format(item);
  });
  $('#linkdatas').html(htmlYoutube);
}

function getData() {
  const car = $('#carSelect').html();
  $.ajax({
    url: 'api/my_vehicle_video.ashx',
    type: 'POST',
    dataType: 'json',
    data: { car },
    success: (result) => {
      if (result.returnCode === '0000') {
        currentDatas = result.datas;
        setYoutubeHtml(result.datas);
        $.address.value(`?car=${car}`);
      }
    },
  }).fail((e) => {
    console.log('error', e);
  });
}

// $.address.parameter 這邊抓不到，故改用substring
function GetURLParameter(sParam) {
  const getParaFromUrl = $.address.parameter('car');
  if (getParaFromUrl !== '' && getParaFromUrl !== undefined) {
    return unescape(getParaFromUrl);
  }
  const sPageURL = window.location.search.substring(1);
  const sURLVariables = sPageURL.split('&');
  for (let i = 0; i < sURLVariables.length; i += 1) {
    const sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return unescape(sParameterName[1]);
    }
  }
}

export function initDatas() {
  const urlParameterCar = GetURLParameter('car');
  $.ajax({
    url: 'api/my_vehicle_video_init.ashx?type=types',
    type: 'POST',
    dataType: 'json',
    data: {},
    success: (result) => {
      if (result.returnCode === '0000') {
        let typeHtml = '';
        result.datas.forEach((item) => {
          typeHtml += typesHtmlFormat.format({ val: item.txt });
        });
        $('#types').html(typeHtml);
        $('#typeSelect').html(result.datas[0].txt);
        typesData = result.datas;
      }
    },
  }).fail((e) => {
    console.log('error', e);
  });

  $(document).on('click', '.typeClass', function click() {
    const val = $(this).html();
    $('#typeSelect').html(val);
    const typ = typesData.find((x) => x.txt === val);
    let datas = [];
    if (typ.val !== currentType) {
      currentType = typ.val;
      if (typ.val === '-1') {
        datas = currentDatas;
      } else {
        datas = currentDatas.filter((x) => x.type === typ.val);
      }
      setYoutubeHtml(datas);
    }
    setTimeout(() => {
      const car = $('#carSelect').html();
      $.address.value(`?car=${car}`);
    }, 500);
  });
  $(document).on('click', '.carClass', function click() {
    const val = $(this).html();
    $('#carSelect').html(val);
    $('#typeSelect').html(typesData[0].txt);
    currentType = '-1';
    getData();
  });

  $.ajax({
    url: 'api/my_vehicle_video_init.ashx',
    type: 'POST',
    dataType: 'json',
    data: {},
    success: (result) => {
      console.log(result);
      if (result.returnCode === '0000') {
        const { datas } = result;
        let carhtml = '';
        datas.forEach((item) => {
          carhtml += carHtmlFormat.format({ val: item.car });
        });
        $('#cars').html(carhtml);
        if (datas.length > 0) {
          let isInit = false;
          datas.forEach((item) => {
            if (urlParameterCar === item.car) {
              $('#carSelect').html(item.car);
              isInit = true;
            }
          });
          if (isInit === false) {
            $('#carSelect').html(datas[0].car);
          }
          getData();
        }
      }
    },
  }).fail((e) => {
    console.log('error', e);
  });
}

export default {
  initDatas,
};
